module.exports = __webpack_public_path__ + "img/02-9学术会议管理.bb0b0c80.png";